import * as React from 'react'
import Main from '../Components/Main'

import * as m from 'moment'
//import * as _ from 'lodash'

import { T, C, H } from '@homeschooling/sdk'
import Persistence from '../Components/Persistence'

import { Draft, Schedule, Edit, Milestone } from '../Components/Icons'

import Modal from '../Components/Modal'
import AddNoteForm from '../Components/Form/AddNoteForm'
import EditNoteForm from '../Components/Form/EditNoteForm'

import defaultAva from '../Components/brand/default_ava.svg'

import { Fetch } from '../Components/Networking'
import { Caret, Calendar, Notes as PageIcon } from '../Components/Icons'
import { DatePicker } from '../Components/Common'
import Expanded from '../Components/Schedule/Expanded'
import { Helper } from '../Components/Helpers'
//import { InputSwitch } from 'primereact/inputswitch'
//import { MultiSelect } from 'primereact/multiselect'
//import { Calendar } from 'primereact/calendar'

//import ScheduleDay from '../Components/Schedule/ScheduleDay'

import SDKFactory from '../Components/SDKFactory'
import { v4 as uuid } from 'uuid';

interface Props { }

interface State {
    isLoading: boolean,
    notes: T.Progress[]
    students: T.Student[]
    subjects: C.ConstantKey[]
    selectedStudents: T.Student[]
    selectedSubjects: C.ConstantKey[]
    startDate: any
    endDate: any
    timePeriod: string
    total_notes: number
    showAddNote: boolean
    showEditNote: T.Progress | null
    focusSchedule: T.Schedule | null
    limit: number
    page: number
    showDatesMenu: boolean
    showStartDate: boolean
    showEndDate: boolean
    notesHash: string
    sort: string
    order: string
}

export class Notes extends React.Component<Props, State> {
    private sdk = SDKFactory.getNotesSDK()
    private wrapperRef = React.createRef<HTMLInputElement>();


    public constructor(props: Props) {
        super(props)

        let endDate = m().format('YYYY-MM-DD')
        let startDate = m(endDate).subtract('30', 'days').format('YYYY-MM-DD')

        this.state = {
            isLoading: true,
            notes: [],
            subjects: [],
            students: Persistence.getStudents(),
            selectedStudents: Persistence.getStudents(),
            selectedSubjects: [],
            startDate: startDate,
            endDate: endDate,
            timePeriod: 'last30',
            total_notes: 0,
            showAddNote: false,
            showEditNote: null,
            focusSchedule: null,
            limit: 25,
            page: 1,
            showDatesMenu: false,
            showStartDate: false,
            showEndDate: false,
            notesHash: uuid(),
            sort: 'date',
            order: 'desc'
        }

        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event: any) {
        if (this.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
            if (this.state.showDatesMenu || this.state.showStartDate || this.state.showEndDate) {
                this.setState({ showDatesMenu: false, showStartDate: false, showEndDate: false })
            }
        }
    }

    public setPage = (page: number) => {
        if (page > 0 && page <= Math.ceil(this.state.total_notes / this.state.limit)) {
            this.setState({ page })
        }
    }

    public makePagination = (total: number) => {

        let starting = (this.state.page - 1) * this.state.limit + 1
        let ending = this.state.page * this.state.limit

        ending = total < ending ? total : ending

        let dots = []

        let count = Math.ceil(total / this.state.limit)
        let i = 1

        while (i <= count) {
            if (i === this.state.page) {
                dots.push(<div className='button text-primary-900 text-sm font-medium rounded-lg border border-zinc-300 p-2'>{i}</div>)
            } else {
                let thispage = i
                dots.push(<div
                    className='button rounded-lg text-secondary-300 text-sm border-zinc-300 p-2 hover:cursor-pointer'
                    onClick={() => this.setPage(thispage)}
                >{i}</div>)
            }

            i++
        }


        return (
            <div className='w-full flex flex-cols'>
                <div className='flex grow'>
                    Showing {starting} to {ending} of {total}
                </div>
                <div className='flex flex-none items-center flex flex-rows gap-2'>
                    <div className='hover:cursor-pointer' onClick={() => this.setPage(this.state.page - 1)}>Previous</div>
                    {dots}
                    <div className='hover:cursor-pointer' onClick={() => this.setPage(this.state.page + 1)}>Next</div>
                </div>
            </div>
        )
    }

    public getEmptyState = () => {
                return (
                     <div id={`expenses_empty`} className='min-h-2 rounded-lg flex flex-col px-4 py-2 m-1 border border-gray-200 hover:cursor-pointer'>
                        <div className='w-full grid'>
                            <Draft className='fill-slate-500 w-[50%] justify-self-center'/>
                        </div>
                        <div className='w-full text-center text-gray-800 font-semibold text-xl mt-8'>
                            No progress note found for timeperiod.
                        </div>
                        <div className='w-full text-center text-md text-gray-900 font-medium mt-4'>
                            Enter a new note if it is missing.
                        </div>
                    </div>
                )
            }

    public makeNotes = (notes: T.Progress[], total: number) => {

        if(this.state.total_notes !== total){
            this.setState({total_notes: total})
        }

        let rows = []
        let iconClass = 'cursor-pointer fill-slate-500 hover:fill-black mx-1'

        if ( notes.length === 0) {
            rows.push(this.getEmptyState())
        }

        for (let n of notes) {

            const student = n.students ? n.students[0] : { name: '' }
            let date = m(n.date).format('MMM DD YYYY')
            let ava = false ? 'img' : defaultAva
            let subs = C.subject
            let courses = C.getSubjectConstants(n.subject)

            rows.push(
                <div id={`notes_${n.id}`} className='@container min-h-2 rounded-lg flex flex-col px-4 py-2 m-1 border border-gray-200 hover:cursor-pointer'>
                    <div className='flex flex-row'>
                        <div className='flex flex-grow'>
                            {n?.milestone ?
                            <div>
                            <Milestone
                                className='fill-slate-500 mx-1'
                                    size='medium' />
                                    </div> : <div></div>}
                        </div>
                        <div className='h-auto flex flex-row flex-none justify-end p-2'>
                            {(n?.schedule_id !== undefined && Number(n?.schedule_id) > 0) &&
                             <div 
                             onClick={() => this.setState({focusSchedule: n.schedule as T.Schedule})}
                             className='flex hover:cursor-pointer'>
                                <Schedule
                                    className={iconClass}
                                    size='medium' />
                            </div>}
                            <div className='flex hover:cursor-pointer'
                                onClick={() => this.setState({showEditNote: n})}
                                >
                                <Edit
                                    className={iconClass}
                                    size='medium' />
                            </div>
                        </div>

                    </div>
                    <div className='grow text-xs font-light leading-normal font-primary-800 text-left col-span-4'>{subs[n.subject].label} | {courses[n.course].label}</div>
                    <div className='grow text-[2cqw] md:text-xs font-medium leading-normal min-h-[5rem] font-gray-900 text-left overflow-hidden col-span-4'>{Helper.cutString(n.description, 115)}</div>
                    <div className='grow text-xs font-light leading-normal font-gray-600 text-left text-ellipsis col-span-4'>{H.turnMinutesToHours(Number(n.time_spent))}</div>
                    <div className='w-full flex flex-col gap-2 md:gap-0 md:flex-row items-start md:items-center pt-4'>
                        <div className='flex grow'>
                            <div className='w-full flex rounded-lg flex flex-row items-center'>
                                <div className='flex flex-none flex-none'>
                                   <img className="object-cover bg-slate-600 w-6 h-6 rounded-full" src={ava} alt={student.name} />
                                </div>
                                <div className='flex text-right pl-2 text-xs text-ellipsis center-self text-slate-700'>
                                    {student.name}
                                </div>
                            </div>
                        </div>
                        <div className='text-xs font-medium text-right none self-end'>
                            {date}
                        </div>
                    </div>
                </div>)
        }

        return (
            <div className='w-full'>
                <div className='w-full grid grid-cols-2 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-5 gap-1'>
                    {rows}
                </div>
            </div>
        )
    }

    public toggleAddNote = async () => {

        this.setState({ showAddNote: !this.state.showAddNote })
    }

    public toggleEditNote = async () => {

        this.setState({ showEditNote: null })
    }

    public toggleShowSchedule = async () => {

        this.setState({ focusSchedule: null })
    }

    public getAddNoteForm = () => {

        return (<AddNoteForm
            closeForm={() => this.toggleAddNote()}
            inPlaceUpdate={() => this.updateNote()}
            form={{}}
            errors={{}}
        />
        )
    }


        public showExpandedEvent = () => {
    
            let expanded = this.state.focusSchedule ? this.state.focusSchedule : {} as T.Schedule

            return (<Expanded
                event={expanded}
                currentDay={m().format()}
                updateNote={(note: T.Progress) => console.log()}
                updateExpense={(expense: T.Expense) => console.log()}
                close={() => this.toggleShowSchedule()}
                secondary = {true}
            />
            )
        }


    public getEditNoteForm = () => {

        let note = this.state.showEditNote ?? {} as T.Progress

        return (<EditNoteForm
            closeForm={() => this.toggleEditNote()}
            inPlaceUpdate={() => this.updateNote()}
            form={{}}
            errors={{}}
            note={note}
        />
        )
    }

    public updateNote = () => {
        this.setState({page: 1, notesHash: uuid()})
    }

    public setTimePeriod = (range: string) => {
        let endDate = m().format('YYYY-MM-DD')
        let startDate = m().format('YYYY-MM-DD')

        switch (range) {
            case 'last30':
                startDate = m(endDate).subtract(30, 'days').format('YYYY-MM-DD')
                break
            case 'ytd':
                startDate = m(endDate).startOf('year').format('YYYY-MM-DD')
                break
            case 'sytd':
                let year = m().year()
                let july1st = m(`${year}-07-01`)
                startDate = july1st.isBefore() ? july1st.format('YYYY-MM-DD') : `${Number(year) - 1}-07-01`
                break
            case 'custom':
                startDate = '2010-01-01'
                break
        }
        this.setState({ timePeriod: range, showDatesMenu: false, endDate: endDate, startDate: startDate })
    }

    public setDay = (key: string, date: string) => {
        let update = {
            ...this.state,
            [key]: date,
            timePeriod: 'custom'
        }
        this.setState(update)
    }

    public render() {

        const { limit, page, startDate, endDate, timePeriod, notesHash, sort, order } = this.state

        const requestHash = JSON.stringify({ notesHash, limit, page, startDate, endDate })

        let filters = {
            limit: limit,
            offset: (page - 1) * limit,
            start_date: startDate,
            end_date: endDate,
            sort,
            order
        }

        let rangeLabel = 'Select a time range'

        switch (timePeriod) {
            case 'last30':
                rangeLabel = 'Last 30 Days'
                break
            case 'ytd':
                rangeLabel = 'Year To Date'
                break
            case 'sytd':
                rangeLabel = 'School Year To Date'
                break
            default:
            case 'custom':
                rangeLabel = 'Custom'
                break
        }

        return (
            <div className='w-full h-full'>
                <Modal
                    open={this.state.showAddNote}
                    onClose={this.toggleAddNote}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    {this.getAddNoteForm()}
                </Modal>

                <Modal
                    open={this.state.showEditNote !== null}
                    onClose={this.toggleEditNote}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    {this.getEditNoteForm()}
                </Modal>

                <Modal
                    open={this.state.focusSchedule !== null}
                    onClose={this.toggleShowSchedule}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    size='w-1/2'
                >
                    {this.showExpandedEvent()}
                </Modal>

                <Main>
                    <div className='m-10'>
                        <div className='w-full flex-none pb-5'>
                                                    <h1 className='w-full flex flex-rows content-center'>
                                                        <div className='flex none'>
                                                            <PageIcon
                                                                size='large'
                                                                className='fill-gray-900'
                                                            />
                                                        </div>
                                                        <div className='flex flex-grow text-3xl font-semibold '>
                                                            Notes
                                                        </div>
                                                    </h1>
                                                </div>
                        
                        <div className='w-full flex flex-col h-auto border-b'>
                            <div className='w-full flex items-center flex-col py-2 sm:py-0 sm:flex-row gap-4'>
                                <div className='w-auto grow'></div>

                                {/*<div className='w-48 flex-none'>     
                                            <MultiSelect value={this.state.selectedStudents} onChange={(e) => this.handleSelectStudent(e.value)} options={this.state.students} optionLabel="name" placeholder="Select Students" className="w-full md:w-20rem" />
                                        </div>
                                        <div className='w-48 flex-none'>     
                                            <MultiSelect value={this.state.selectedSubjects} onChange={(e) => this.handleSelectSubject(e.value)} options={this.state.subjects} optionLabel="label" placeholder="Select Subjects" className="w-full md:w-20rem" />
                                        </div>
                                        <div className='w-auto grow'></div>
                                        <div className='w-48 flex-none'>
                                            <div className="inline-flex rounded-md shadow-sm" role="group">
                                                <button type="button"  disabled={this.state.timePeriod === 'daily'} onClick={(e) => this.toggleTimePeriod()} className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                                    Daily
                                                </button>
                                                <button type="button" disabled={this.state.timePeriod === 'monthly'} onClick={(e) => this.toggleTimePeriod()} className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                                    Monthly
                                                </button>
                                            </div>
                                        </div>
                                        <div className='w-auto flex-none'>
                                            <Calendar value={[m(this.state.startDate).toDate(), m(this.state.endDate).toDate()]} onChange={(e) => this.setDate(e.value)} selectionMode="range" readOnlyInput hideOnRangeSelection showIcon/>
                                        </div>
                                        {/*<div className='w-auto flex-none'>
                                            <button type="button" onClick={() => this.getSchedule()}className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                                 Go
                                            </button>
                                        </div>*/}
                                <div className='relative flex-none'>
                                    <div ref={this.wrapperRef} className='w-full py-2'>
                                        <div className='w-full'>
                                            <div
                                                className='w-full inline-block text-left px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white'
                                            >
                                                <div className='w-full flex flex-row gap-3 items-center'>
                                                    <div className='none'><Calendar size='medium' /></div>
                                                    <div onClick={() => this.setState({ showStartDate: !this.state.showStartDate, showEndDate: false, showDatesMenu: false })}
                                                        className='flex-grow font-semibold underline underline-offset-4 hover:cursor-pointer'>{`${m(startDate).format('MMM DD, YYYY')}`}</div>
                                                        <div> - </div>
                                                    <div onClick={() => this.setState({ showStartDate: false, showDatesMenu: false, showEndDate: !this.state.showEndDate })}
                                                        className='flex-grow font-semibold underline underline-offset-4 hover:cursor-pointer'>{`${m(endDate).format('MMM DD, YYYY')}`}</div>    
                                                    <div className='none'> | </div>
                                                    <div onClick={() => this.setState({ showEndDate: false, showStartDate: false, showDatesMenu: !this.state.showDatesMenu })} className='flex flex-cols items-center gap-2  hover:cursor-pointer'>
                                                        <div className='none'>{rangeLabel}</div>
                                                        <div className='none rotate-180'><Caret size='small' /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.showStartDate &&
                                            <div className='absolute z-10 left-0 mt-1 origin-top-left dark:bg-gray-800 rounded-md'>
                                                <DatePicker date={this.state.startDate} cb={(date: string) => this.setDay('startDate', date)} inline/>
                                            </div>
                                        }
                                        {this.state.showEndDate &&
                                            <div className='absolute z-10 left-[30%] mt-1 origin-top-left dark:bg-gray-800 rounded-md'>
                                                <DatePicker date={this.state.endDate} cb={(date: string) => this.setDay('endDate', date)} inline/>
                                            </div>
                                        }
                                        {this.state.showDatesMenu &&
                                            <ul className="absolute z-10 right-0 mt-1 w-content origin-top-left rounded-md bg-white  dark:bg-gray-800 rounded-md shadow-lg ring-1 ring-black/5 focus:outline-hidden ">
                                                <li>
                                                    <button type='button' onClick={() => this.setTimePeriod('last30')} className="block text-left w-full text-white p-2 hover:bg-gray-100 rounded-t-md dark:hover:bg-gray-600 dark:hover:text-white">Last 30 days</button>
                                                </li>
                                                <li>
                                                    <button type='button' onClick={() => this.setTimePeriod('ytd')} className="block text-left  w-full text-white p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Year to Date</button>
                                                </li>
                                                <li>
                                                    <button type='button' onClick={() => this.setTimePeriod('sytd')} className="block text-left  w-full text-white p-2 hover:bg-gray-100 rounded-b-md  dark:hover:bg-gray-600 dark:hover:text-white">School Year To Date</button>
                                                </li>
                                            </ul>
                                        }
                                    </div>
                                </div>
                                <div className='w-full sm:w-auto flex-none flex flex-row justify-end'>
                                    <button type="button" onClick={() => this.toggleAddNote()} className="w-full sm:w-auto px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                        Add Note
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className='w-full grow h-auto border-b'>


                            <Fetch key={requestHash} sdk={this.sdk} method={this.sdk.getFamilyNotes} params={[filters]}>
                                {(data: any) => (
                                    <div className='w-full'>
                                        {this.makeNotes(data.notes, data.total)}
                                        <div className='w-full py-4'>
                                            {this.makePagination(data.total)}
                                        </div>
                                    </div>

                                )}
                            </Fetch>

                        </div>

                    </div>

                </Main>
            </div>
        )
    }
}

export default Notes